import { APP_API_URL } from "../constants";
import { getRailsClient } from "../client";

const API = `${APP_API_URL}/internal_api/v1`;
const COUNTRIES_PATH = `${API}/countries`;

export interface CountryOption {
  label: string;
  value: string;
}

export const fetchCountriesList = async (): Promise<CountryOption[]> => {
  try {
    const { data } = await getRailsClient().get(COUNTRIES_PATH);

    return data
      .sort((a: string, b: string) => a.localeCompare(b))
      .map((country: string) => ({
        label: country,
        value: country,
      }));
  } catch (error) {
    console.error("Error fetching countries:", error);
    return [];
  }
};
